import { CurrencyPipe } from '@angular/common';

export class moduledetails {
    accessdays: number = 90;
    price: CurrencyPipe;
    available: boolean = false;
    courseCode: string;
    description: string;
    displayCourseCode: boolean;
    sendCertificateOnCompletion:boolean=true;
    userCompleteCourseWhenAllLessonsAreCompleted:boolean=true;
    featured: boolean;
    name: string;
    schoolID: number = 0;
    passScorePercentage:number = 0;
    requireEnrollment: boolean = true;
    requireLessonCompletion: boolean = true;
    id: number = 0;
    logo: string;
    publishDate: Date;
    retakemultiplechoice: boolean = false;
    allowBatches: boolean = false;
    sendMarkedNotification: boolean = false;
    activateLessonDeadlineNotification: boolean = false;
}

export class abridgedclass {
    id: number;
    title: string;
    description: String;
    moduleid: number;
    publishdate: Date;
    //publishdatestring:string
    classposition: number;
    timenumber: number;
    timeunit: number;
    milestonetimenumber: number;
    milestonetimeunit: number;
    usefixeddeadline: boolean;
}

export class liveclassschedule{
    id: number;
    schoolModuleClassId: number;
    scheduleDateTime: Date;
    scheduleDateTimeString: string;
    userprofilenowdatetimestring:string;
    mode: string;
    allowStudentsDownloadRecording: boolean;
    sendemailnotification: boolean;
    utcScheduledDateTime: Date;
    meetingId:string;
}

export class lessondetails {
    title: string;
    lectureid: number;
    upcominglectureid: number;
    upcominglecturetimestring: string;
    adminuser: boolean;
    modulename: string;
    moduleid: number;
    moduleclasses: any[];
    assessments: number;
    schoolname: string;
    schoolid: number;
    lesson: any;
    note: any;
    uploadedvideos: any[];
    lecture: any;
    completed: boolean;
    moduleRequiresLessonCompletion: boolean = false;
    batchid: number;
    inclassAssessementID:number;
    hasInclassAssessement: boolean;
}

export class lessonnote {
    schoolModuleClassID: number = 0
    title: string = '';
    content: any = '';
    id: number = 0;
    adminUser: boolean = false;
    safeContent: string;
    page: number;
}

export class modulemedia{
    id: number = 0;
    moduleid: number = 0;
    title: string = '';
    selected: boolean = false;
    playerurl: string;
    mediaurl: string;
    hlsmediaurl: string;
    type:string = '';
    processed: boolean = false;
    errorprocessing: boolean = false;
    userisadmin: boolean = false;
    size: number = 0;
    uploaddate: Date = new Date();
    uploadid: string = '';
}

export interface SchoolModuleEvent {
  id: number;
  subject: string;
  body: string;
  venue: string;
  inviteStartDate: Date;
  inviteEndDate: Date;
  uniqueId: string;
  isCancelled: boolean;
  moduleID: number;
  schoolId: number;
  eventCssColor: string;
  batchId: number;
  batchName: string;
  classId:number
  lessonTitle: string;
}
export interface SchoolModuleBatch {
  id: number;
  name: string;
  startDate: Date;
  endDate: Date;
  moduleID: number;
  meetingID: string;
}

